module.exports = __webpack_public_path__ + "static/home-ourproduct-foodbank-74dc6ce13fe06f9a8d0ed95f4ed9caa3.png";